export const SESSION_STORAGE_KEYS = {
    REFERRER_ADSC: 'referrer_adsc',
    REFERRER_ADSC_EXPIRY_DATE: 'referrer_adsc_expiry_date',
    REPEAT_BOOKING: 'repeat_booking',
    BANNER_SHOWN: 'bannerShown',
    REWARD_VALUE: 'rewardValue',
    REWARD_RULE: 'rewardRule',
    UTM_MEDIUM: 'utm_medium',
    REWARD_TITLE: 'rewardTitle',
    SERVICE_TYPE: 'serviceType',
};

export const LOCAL_STORAGE_KEYS = {
    GARAGE_ID: 'garage_id',
    PINCODE: 'pincode',
};
